//Library Imports
import React from 'react';
import { useEffect, useState } from 'react';
import { RootState } from 'store';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getQuerySalesXGroupId } from 'utils';

//Local Imports
import { createGroupForExportWidgets, deleteSalesXGroup, getSalesXGroupsAction, resetGroups } from '../actions';
import ButtonRightIconGreen from 'modules/Common/Components/ButtonRightIconGreen';
import SentEmailSearch from '../../../Campaigns/Emails/Components/SentEmailSearch';
import GroupListItem from '../GroupListing/GroupListItem';
import PlusIcon from 'assets/img/icons/Article/Plus.svg';

//Style Imports
import styled from 'styled-components';
import InfiniteLoader from 'modules/Common/Components/InfiniteLoader';
import SalesXGroupsLoader from '../Loaders/SalesXGroupsLoader';
import { Spin } from 'antd';
import EmptyTabInfo from 'modules/Content/Shared/EmptyTabInfo';
import ConfirmDialogWithModal from 'modules/Common/Components/ConfirmDialogWithModal';

const ListingWrapper: React.FC = () => {
  // default Objects
  const DEFAULT_CONFIRM_DELETE_OBJECT = { id: -1, groupName: '', open: false };

  // useQuery
  const queryParamSalesxGroupId = getQuerySalesXGroupId();
  const queryParams = new URLSearchParams(window.location.search);

  // Local States
  const history = useHistory();
  const [confirmDelete, setConfirmDelete] = useState(DEFAULT_CONFIRM_DELETE_OBJECT);

  // Redux States
  const groups = useSelector((state: RootState) => state.salesXGroups.groups.data);
  const groupCreateLoading = useSelector((state: RootState) => state.salesXGroups.groups.createLoading);
  const groupsLoading = useSelector((state: RootState) => state.salesXGroups.groups.loading);
  const groupName = useSelector((state: RootState) => state.salesXGroups.selectedGroup.groupName);
  const [searchTerm, setSearchTerm] = useState('');

  // Functions

  const searchHandler = (text: any) => {
    resetGroups();
    setSearchTerm(text);
    let object: any = {};
    object.limit = 10;
    object.offset = 0;
    object.searchTerm = text;
    object.groupId = queryParamSalesxGroupId;
    getSalesXGroupsAction(object);
    // object.groupId = queryParamSalesxGroupId;
  };

  const resetSearch = () => {
    resetGroups();
    setSearchTerm('');
    let object: any = {};
    object.limit = 10;
    object.offset = 0;
    object.groupId = queryParamSalesxGroupId;
    getSalesXGroupsAction(object);
  };

  const getPagination = () => {
    let object: any = {};
    object.limit = 10;
    object.offset = groups.length;
    object.groupId = queryParamSalesxGroupId;
    if (searchTerm !== '') {
      object.searchTerm = searchTerm;
    }
    return object;
  };

  const handleNext = () => {
    getSalesXGroupsAction(getPagination());
  };
  const createSalesXGroup = () => {
    createGroupForExportWidgets(groupName, history);
  };
  const handleOnGroupClick = (id: number) => {
    let url = `/settings/groups/group-list?`;
    if (queryParams.has('exportPopup')) {
      if (queryParams.has('group_id')) {
        queryParams.delete('group_id');
      }
      queryParams.append('group_id', id.toString());
      history.push(url + queryParams.toString());
    } else {
      history.push(`/settings/groups/group-list?group_id=${id}`);
    }
  };

  const confirmDeleteHandler = () => {
    deleteSalesXGroup(confirmDelete.id).then((res) => {
      setConfirmDelete(DEFAULT_CONFIRM_DELETE_OBJECT);
    });
  };

  const cancelConfirmationDeleteHandler = () => {
    setConfirmDelete(DEFAULT_CONFIRM_DELETE_OBJECT);
  };

  useEffect(() => {
    getSalesXGroupsAction(getPagination());
  }, []);

  return (
    <>
      <Wrapper>
        <div className="wrapper-listing">
          <div className="d-flex justify-content-between searchAndBtn_styles">
            <div className="pe-3 search-group search_styles">
              <SentEmailSearch value={searchTerm} handleSearch={searchHandler} reset={resetSearch} placeholder="Search for Email/Name" />
            </div>
            <div className="create-group-btn-wrap">
              {groupCreateLoading ? (
                <LoadingWrapper>
                  <Spin />
                </LoadingWrapper>
              ) : null}
              <ButtonRightIconGreen
                idBtn="manage-group-list-qa"
                label="Create Group"
                icon={PlusIcon}
                classIcon="plus15 px-2"
                onClick={() => {
                  if (searchTerm !== '') {
                    resetGroups();
                  }
                  createSalesXGroup();
                }}
                disabled={groupCreateLoading}
              />
            </div>
          </div>
          <div className="d-flex flex-column groups">
            <InfiniteLoader
              dataLength={groups.length}
              next={handleNext}
              hasMore={true}
              loader={<SalesXGroupsLoader loading={groupsLoading} count={5} />}
            >
              {groups.length === 0 && !groupsLoading ? (
                <EmptyTabInfo description={`No groups found ${searchTerm !== '' ? 'against your search' : ''}`} />
              ) : groups.length === 0 && groupsLoading ? (
                <SalesXGroupsLoader loading={groupsLoading} count={5} />
              ) : null}
              {groups.map((group) => (
                <GroupListItem
                  key={group.groupId}
                  id={group.groupId}
                  name={group.groupName}
                  time={group.lastUpdated}
                  contactCount={group.totalUsers}
                  onClick={() => {
                    resetGroups();
                    handleOnGroupClick(group.groupId);
                  }}
                  onDeleteHandler={() => {
                    setConfirmDelete({ id: group.groupId, groupName: group.groupName, open: true });
                  }}
                  isEditable={group.isDeletable}
                />
              ))}
            </InfiniteLoader>
          </div>
        </div>
      </Wrapper>
      {confirmDelete.open ? (
        // <ConfirmationWrapper>
        <ConfirmDialogWithModal
          cancel={'Cancel'}
          confirm={'Yes'}
          onConfirm={confirmDeleteHandler}
          onCancel={cancelConfirmationDeleteHandler}
          // icon={whiteRoy}
          title={
            <>
              The <strong>"{confirmDelete?.groupName}"</strong> will be deleted.
            </>
          }
        />
      ) : // </ConfirmationWrapper>
      null}
    </>
  );
};

export default ListingWrapper;

const BackOverlay = styled.div`
  position: fixed;
  background: grey;
  opacity: 0.2;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
`;

const Wrapper = styled.div`
  .groups {
    margin-top: 7px;
  }
  .searchAndBtn_styles {
    margin-top: 17px;
    margin-bottom: 32px;
  }
  .search_styles {
    width: 700px;
  }
  .create-group-btn-wrap {
    position: relative;
  }
  .create-group-btn-wrap > button > span {
    min-width: fit-content;
  }
`;

const LoadingWrapper = styled.div`
  position: absolute;
  top: 6px;
  right: -30px;
  /* bottom: 0;
  left: 0; */
  z-index: 1;
  /* background: rgba(220,220,220, 0.3); */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ConfirmationWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /* background: rgba(220,220,220, 0.3); */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
